import { Component, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';

export interface MenuItem {
    name: string;
    path?: string;
    icon?: string;
    isSubmenu?: boolean;
    childs?: MenuItem[];
}

export interface MenuGroup extends MenuItem {
    childs: MenuItem[];
}

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent {
    @Input() entries: MenuItem[] = [];

    @Output() menuItemClicked = new EventEmitter<void>();
    @Output() submenuClicked = new EventEmitter<MenuItem>();

    onItemClick(): void {
        this.menuItemClicked.emit();
    }

    onSubmenuClick(item: MenuItem): void {
        this.submenuClicked.emit(item);
    }

    trackByFn(index: number, item: MenuItem): string {
        return item.name + index;
    }

    isGroup(item: MenuItem): item is MenuGroup {
        return 'childs' in item && Array.isArray(item.childs);
    }
}
